import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { toFullName } from '@repo/toolkit/to-full-name'
import { ChevronDownIcon, LogoutIcon } from '@repo/ui/icons'
import Popover from '@repo/ui/popover'
import Typography from '@repo/ui/typography'
import { useMemo } from 'react'

import useAuth from '../../lib/hooks/use-auth'
import { olTypeEnumMapping } from '../../lib/types/enums/ol/ol-type.enum'
import { staffPositionEnumMapping } from '../../lib/types/enums/staff/staff-position.enum'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { getUserImage } from '../../lib/utils/functions/user.functions'
import { t } from '../../locale/utils'

const UserMenu = () => {
  const { user, logout } = useAuth()
  const userDetail = useMemo(() => {
    if (!user) return undefined

    if (user.role === RoleEnum.Ol)
      return user.ol?.type ? olTypeEnumMapping[user.ol.type].label : undefined

    if (user.role === RoleEnum.ADMIN) return user.isMasterLec ? 'Admin - Master LEC' : 'Admin'

    if (user.role === RoleEnum.STAFF)
      return user.staff?.position ? t(staffPositionEnumMapping[user.staff.position]) : undefined

    return undefined
  }, [user?.isMasterLec, user?.ol?.type, user?.role, user?.staff?.position])

  return (
    <Popover
      triggerComponent={(open) => (
        <button className="flex flex-row items-center gap-2.5 mobile:hidden">
          <img src={getUserImage(user)} className="w-8 h-8 rounded-full object-cover" />
          <div className="flex flex-row items-center gap-1">
            <Typography variant="tag" className="select-none">
              {toFullName(user?.firstName, user?.lastName)}
            </Typography>
            <ChevronDownIcon
              color={tailwindColors.grey.DEFAULT}
              className={cn(
                'transition-transform duration-300 mt-1',
                open && 'transform rotate-180'
              )}
            />
          </div>
        </button>
      )}
      title={toFullName(user?.firstName, user?.lastName)}
      position="end"
    >
      {userDetail && (
        <div className="px-4 py-3 border-b border-white-active">
          <Typography variant="secondary-body" color={tailwindColors.grey.DEFAULT}>
            {userDetail}
          </Typography>
        </div>
      )}
      <div className="flex gap-2 p-4 items-center ">
        <LogoutIcon color={tailwindColors.red.DEFAULT} />
        <button type="button" onClick={logout}>
          <Typography variant="tag" color={tailwindColors.red.DEFAULT}>
            {t('logout')}
          </Typography>
        </button>
      </div>
    </Popover>
  )
}

export default UserMenu
